import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import styles from './DragDrop.module.css'
import { DROPZONE_ACCEPTED_FILES } from 'constants.js'

const DragDropArea = ({ onFileSelected, acceptedFiles = DROPZONE_ACCEPTED_FILES, maxFileSize = 16 }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        onFileSelected(acceptedFiles)
      }
    },
    [onFileSelected]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedFiles
  })

  return (
    <div {...getRootProps()} className={`${styles.dragDropContainer} ${isDragActive ? styles.dragActive : ''}`}>
      <input data-testid={'UpdateSiteModal-selectedfile-dragdroparea-input'} {...getInputProps()} />

      <div className={styles.contentContainer}>
        <p className={styles.dragText}>Drag and drop more files or</p>

        <button type="button" className={styles.uploadButton}>
          Choose files to upload
        </button>
      </div>
    </div>
  )
}

export default DragDropArea
